import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import SweetAlert from "sweetalert2";
import { Link } from "react-router-dom";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveCurrencies } from "../../redux/ecommerce/currency/actions";

const SalesReport = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        fromDate: new Date().toISOString().split('T')[0], // Today's date
        toDate: new Date().toISOString().split('T')[0]    // Today's date
    });
const {currencies} = useSelector(state => state.Currency);
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchActiveCurrencies()); // must be called
  }, [dispatch]);
    useEffect(() => {
        getData();
    }, []);

    const getData = (customFilters = null) => {
        setLoading(true);
        setData([]); // Reset data before fetching new data

        const currentFilters = customFilters || filters;
        const requestData = {
            from_date: currentFilters.fromDate,
            to_date: currentFilters.toDate
        };

        axiosConfig.post("get-sales-report-by-date", requestData, setHeader())
            .then((res) => {
                setData(res.data.data);
                
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                SweetAlert.fire({
                    title: "Error",
                    text: "Failed to fetch sales report data.",
                    icon: "error",
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();

        // Validate dates
        if (filters.fromDate && filters.toDate && filters.fromDate > filters.toDate) {
            SweetAlert.fire({
                title: "Invalid Date Range",
                text: "From date cannot be greater than To date.",
                icon: "warning",
            });
            return;
        }

        getData(filters);
    };

    const handleReset = () => {
        const todayDate = new Date().toISOString().split('T')[0];
        const resetFilters = {
            fromDate: todayDate,
            toDate: todayDate
        };
        setFilters(resetFilters);
        getData(resetFilters);
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        });
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount);
    };

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <Fragment>
            <Breadcrumb title="Sales Reports" parent="Reports" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        {/* Results Section */}
                        <div className="card">
                            {/* Filter Section */}
                            <div className="card">
                                <div className="">
                                    <h5 className="card-titlee mb-0" style={{paddingLeft:'1rem',paddingTop:'1rem',fontWeight:'700'}}>Filter Sales Report</h5>
                                </div>
                                <div className="card-body p-3">
                                    <form onSubmit={handleFilterSubmit}>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="fromDate"
                                                        name="fromDate"
                                                        value={filters.fromDate}
                                                        onChange={handleFilterChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="toDate"
                                                        name="toDate"
                                                        value={filters.toDate}
                                                        onChange={handleFilterChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <div className="d-flex gap-2">
                                                        <button type="submit" className="btn btn-primary">
                                                            Apply Filter
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={handleReset}
                                                        >
                                                            Reset
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card-header p-3" style={{marginTop:'-3rem'}}>
                                <h5 className="card-title">
                                    Sales Report ({formatDate(filters.fromDate)} to {formatDate(filters.toDate)})
                                </h5>
                            </div>
                            <div className="card-body">
                                {data.length === 0 ? (
                                    <NoDataHandler title='No Sales Found for Selected Date Range' height='100px' />
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{"#"}</th>
                                                    <th scope="col">Order ID</th>
                                                    <th scope="col">Invoice No.</th>
                                                    <th scope="col">Order Date</th>
                                                    <th scope="col">Customer</th>
                                                    <th scope="col">Total Amount</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item, index) => {
                                                    return (
                                                        <tr key={item.id || index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.order_id || 'N/A'}</td>
                                                            <td>{item.invoice_no || 'N/A'}</td>
                                                            <td>{item.order_date ? formatDate(item.order_date) : 'N/A'}</td>
                                                            <td>{item.username || 'N/A'}</td>
                                                            <td>{currencies?.symbol} {item.totalAmount}</td>
                                                            <td><Link to={`/pages/sales-report/order-details/${item.o_id}`} className="btn btn-primary">View</Link></td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>

                                        {/* Summary Section */}
                                        <div className="mt-3 p-3 bg-light rounded">
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <strong className="text-black">Total Orders: {data.length}</strong>
                                                </div>
                                                <div className="col-md-4 text-right">
                                                    <strong className="text-black">
                                                        Total Sales: {formatCurrency(
                                                            data.reduce((sum, item) => sum + (parseFloat(item.totalAmount) || 0), 0)
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default SalesReport;
